// extracted by mini-css-extract-plugin
module.exports = {"inputDisplay":"styles_inputDisplay__k0lkG"};